export enum OrderTypeEnum {
    ON_THE_SPOT = 'Sur Place',
    TAKE_AWAY = 'A Emporter',
    DELIVERY = 'En Livraison',
    PLATEFORM = 'Plateform'
}
